module.exports = __webpack_public_path__ + "assets/call-now-confirmation-screen-icon.f93ab4c3.png";